import Page from '@/found/components/table_page/table_page.vue';
import Form from './form';

export default {
  extends: Page,
  data() {
    return {
      formConfig: {},
      configs: {
        formConfig: {},
      },
      modalConfig: {},
    };
  },
  components: { Form },
  created() {
    this.getConfigList('shareList');
  },
  methods: {
    /**
     * 列表点击事件
     * @param {object} val 点击对象绑定数据
     * @param {object} row 点击列表行数据
    */
    clickVisible({ row, val: { code } }) {
      // val: 当前按钮配置信息
      //    code: 按钮编码
      if (code === 'shareAppr') {
        return row.approvalStatus === '0';
      }
      return true;
    },
    modalClick({
      val,
      row,
    }) {
      const {
        code,
        name,
      } = val;
      this.formName = 'Form';
      console.log(code);
      if (code === 'shareAppr' || code === 'view') {
        this.modalConfig.title = name;
        this.formConfig = {
          code,
          row,
        };
        this.openFull();
      }
    },
  },
};
